import { render, staticRenderFns } from "./ParticipantInfo.vue?vue&type=template&id=a772caf4&scoped=true&"
import script from "./ParticipantInfo.vue?vue&type=script&lang=js&"
export * from "./ParticipantInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantInfo.vue?vue&type=style&index=0&id=a772caf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a772caf4",
  null
  
)

export default component.exports